(function() {
    console.debug(`Running as APP_ENV: ${window.APP_ENV}`);
})();